


























































































































































































import {
  Vue,
  Component,
  Prop,
  Watch
} from "@/shared/vuepack";
import {
  InvestmentCustodian,
  FeatureFlags,
  HsabSsoDestination,
  EmployeeNavItem
} from "@/shared/types";
import * as RouteNames from "@/employee/route-names";
import ValueBadge from "@/shared/components/ui/ValueBadge.vue";
import SsoDeepLink from "@/shared/components/ui/SsoDeepLink.vue";
import HsabInvestmentRedirectPage from "@/employee/components/investments/HsabInvestmentRedirectPage.vue";
import { isMobileApp } from "@/shared/mobileHelper";
import { useUserStore } from "@/shared/store/user";
import { useExpenseBalanceSummaryStore } from "@/employee/store/expenseBalanceSummary";
import { useNavigationStore } from "@/shared/store/navigation";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";
import { useBankAccountStore } from "@/employee/store/bankAccount";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";
import { useHsabInvestmentStore } from "@/shared/store/hsabInvestment";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useInvestmentThresholdStore } from "@/shared/store/investmentThreshold";
import { useThemeStore } from "@/shared/store/theme";
import { useFdicStore } from "@/shared/store/fdic";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

const dashboardNavItem = "dashboard";
const balancesNavItem = "balancesActions";
const contributionPlannerNavItem = "contributionPlannerActions";
const resourcesNavItem = "resources";
const changePlansNavItem = "changePlans";
const healthcareExpensesNavItem = "healthcareExpenses";
const settingsNavItem = "settings";
const investNavItem = "invest";
const contributionActionsNavItem = "contributionsActions";
const productScannerNavItem = "productScanner";
const notionalDashboardNavItem = "notional-dashboard";

@Component({
  components: {
    ValueBadge,
    SsoDeepLink,
    HsabInvestmentRedirectPage
  }
})
export default class NavV2 extends Vue {
  userStore = useUserStore();
  expenseBalanceSummaryStore = useExpenseBalanceSummaryStore();
  navigationStore = useNavigationStore();
  custodianSettingsStore = useCustodianSettingsStore();
  bankAccountStore = useBankAccountStore();
  featureFlagStore = useFeatureFlagStore();
  hsabInvestmentStore = useHsabInvestmentStore();
  hsabAccountsStore = useHsabAccountsStore();
  investmentThresholdStore = useInvestmentThresholdStore();
  themeStore = useThemeStore();
  fdicStore = useFdicStore();
  drivewealthStore = useDrivewealthStore();

  afterRoutedHook: any;
  RouteNames = RouteNames;
  investmentsAdvancedNavVisible = false;

  @Prop()
  open: boolean;

  navItemActive = EmployeeNavItem.None;

  closeNav () {
    this.navigationStore.closeMobileMenu();
  }

  get useInvestmentsAdvancedNav (): boolean {
    return this.drivewealthStore.hasAccountIdOrIds && this.featureFlagStore.flags.bend25653EnableDrivewealthPerformance;
  }

  get portalFunctionalityDisabled (): boolean {
    return this.custodianSettingsStore.portalFunctionalityDisabled;
  }

  get isEverythingLoaded () {
    return this.custodianSettingsStore.isLoaded
        && this.featureFlagStore.featureFlagsAvailable
        && this.investmentThresholdStore.thresholdsLoaded;
  }

  get showDashboardLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { Home, Dashboard } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Home] || this.custodianSettingsStore.disabledRoutes[Dashboard]) {
      return false;
    }

    return true;
  }

  get dashboardRouteName (): string {
    if (this.featureFlagStore.flags.bend25644EnableSummaryDashboard) {
      return RouteNames.Summary;
    } else {
      return RouteNames.Home;
    }
  }

  get dashboardNavigationName (): string {
    if (this.featureFlagStore.flags.bend25644EnableSummaryDashboard) {
      return "Summary";
    } else {
      return "Dashboard";
    }
  }

  get showCashAccountLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { CashBalance } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[CashBalance]) {
      return false;
    }

    return true;
  }

  get hsabDeepLinkDashboard () {
    return HsabSsoDestination.Dashboard;
  }

  get hsabDeepLinkPayment () {
    return HsabSsoDestination.DistributeFund;
  }

  get hsabDeepLinkMessageCenter () {
    return HsabSsoDestination.MessageCenter;
  }


  get showNewClaims (): boolean {
    return this.custodianSettingsStore.displayNewHealthcareExpenses &&
        this.custodianSettingsStore.showHealthcareExpensesV2;
  }

  get hsabDeepLinkFileClaim () {
    return HsabSsoDestination.FileClaim;
  }

  get showContributionsLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { Contribution } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Contribution]) {
      return false;
    }

    return true;
  }

  get showContributionPlannerLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { ContributionPlanner } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[ContributionPlanner]) {
      return false;
    }

    return true;
  }

  get showResourcesLink (): boolean {
    if (this.userStore.isNotionalDashboardActive) {
      return false;
    }
    const { Resources } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Resources]) {
      return false;
    }

    return true;
  }

  get showSettingsLink (): boolean {
    const { Settings } = RouteNames;
    if (this.custodianSettingsStore.disabledRoutes[Settings]) {
      return false;
    }

    return true;
  }

  get showProductScannerLink () {
    if (this.userStore.isNotionalDashboardActive || this.bankAccountStore.isBankAccountClosed) {
      return false;
    }

    return isMobileApp();
  }

  get settingsUrl (): string {
    if (this.custodianSettingsStore.displaySettingsLinkedAccounts && !this.userStore.isNotionalDashboardActive) {
      return "/settings";
    }

    return "/settings/my-profile";
  }

  get showReimburseLink (): boolean {
    return this.custodianSettingsStore.allowReimbursement && !this.bankAccountStore.isBankAccountClosed;
  }

  get dashboardLinkActive () {
    if (this.featureFlagStore.flags.bend25644EnableSummaryDashboard) {
      return this.navItemActive === EmployeeNavItem.Summary;
    } else {
      return this.navItemActive === EmployeeNavItem.Dashboard;
    }
  }

  get notionalDashboardLinkActive () {
    return this.navItemActive === EmployeeNavItem.NotionalDashboard;
  }

  get balancesLinkActive () {
    return this.navItemActive === EmployeeNavItem.Balances;
  }

  get healthcareLinkActive () {
    return this.navItemActive === EmployeeNavItem.HealthcareExpenses;
  }

  get contributionsLinkActive () {
    return this.navItemActive === EmployeeNavItem.Contributions;
  }

  get contributionPlannerLinkActive () {
    return this.navItemActive === EmployeeNavItem.ContributionPlanner;
  }

  get investLinkActive () {
    return this.navItemActive === EmployeeNavItem.Invest;
  }

  get messageCenterLinkActive () {
    return this.navItemActive === EmployeeNavItem.MessageCenter;
  }

  get settingsLinkActive () {
    return this.navItemActive === EmployeeNavItem.Settings;
  }

  get productScannerLinkActive () {
    return this.navItemActive === EmployeeNavItem.ProductScanner;
  }

  get changePlansLinkActive () {
    return this.navItemActive === EmployeeNavItem.ChangePlans;
  }

  get resoursesLinkActive () {
    return this.navItemActive === EmployeeNavItem.Resources;
  }

  get showInvestmentsLink () {
    return !this.userStore.isNotionalDashboardActive &&
            this.investmentThresholdStore.displayInvestmentsSection;
  }

  get showLegacyHsabInvestmentsRedirectLink () {
    return !this.userStore.isNotionalDashboardActive &&
            this.investmentThresholdStore.displayLegacyHsabInvestmentsRedirectLink;
  }

  @Watch("$route", {deep: true})
  watchRoute () {
    this.navItemActive = this.$router.currentRoute.meta.nav_item
        ? this.$router.currentRoute.meta.nav_item
        : EmployeeNavItem.None;
  }

  created () {
    this.expenseBalanceSummaryStore.loadState();
    this.afterRoutedHook = this.$router.afterEach(this.closeNav);
    this.custodianSettingsStore.getCustodianSettings();
    this.bankAccountStore.getBankAccountStatus();
    this.investmentThresholdStore.loadInvestmentThresholds({});
  }

  beforeDestroy () {
    this.afterRoutedHook();
  }
}

